import { downloadImageType, errorMessages } from "../../../assets/config";
import { getCurrentCanvas } from "../../../helpers/helper";

export function DownloadImage(name = "", type = "image", isDownload = true, positionCanvas = null) {
  let url = "";

  const drawableArea = (positionCanvas ?? getCurrentCanvas()).getObjects().find((obj) => obj.id === "drawableArea");

  drawableArea.set("stroke", "transparent");
  const previousValue = [...(positionCanvas ?? getCurrentCanvas()).viewportTransform];
  (positionCanvas ?? getCurrentCanvas()).setViewportTransform([1, 0, 0, 1, 0, 0]);

  if (type === "json") {
    const canvasData = JSON.stringify((positionCanvas ?? getCurrentCanvas()).toJSON(["id", "selectable","controlsVisibility","libraryId","overlayImgScaleY","overlayImgScaleX"]));
    const canvasBlob = new Blob([canvasData], { type: "application/json" });
    url = URL.createObjectURL(canvasBlob);
  }

  try {
    if (type === "image") {
      url = (positionCanvas ?? getCurrentCanvas()).toDataURL({
        format: downloadImageType,
        multiplier: 4
      });
    }
  } catch (error) {
    alert(errorMessages.SERVER_ERROR);
  }


  if (!isDownload) {
    (positionCanvas ?? getCurrentCanvas()).setViewportTransform(previousValue);
    drawableArea.set("stroke", "red");
    (positionCanvas ?? getCurrentCanvas()).renderAll()
    return url;
  }

  if (url) {
    const a = document.createElement("a");
    a.href = url;
    a.download = name;
    a.click();

    (positionCanvas ?? getCurrentCanvas()).setViewportTransform(previousValue);
    drawableArea.set("stroke", "red");
    (positionCanvas ?? getCurrentCanvas()).renderAll();

    // Release the URL object
    URL.revokeObjectURL(url);
  }
}
